import React from 'react';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';

const Container = styled.div`
    border: 1px solid lightgrey;
    border-radius: 2px;
    padding: 8px;
    margin-bottom: 8px;
    background-color: ${props => (
        props.isDragDisabled
            ? 'lightgrey'
            : props.isDragging 
                ? 'lightgreen' 
                : 'white')};

    display: flex;
`;


const IndexHolder = styled.div`
    width: 30px;
    height: 20px;
    background-color: orange;
    border-radius: 20px;
    margin-right: 8px;

    text-align: center;
    font-weight: 700;

`;


export default class DnDTask extends React.Component {

    render() {
        const isDragDisabled = false;

        let taskId = <div></div>;
        if (this.props.columnId === 'ChosenTasks') {
            taskId = <IndexHolder>{this.props.currentIndex+1}</IndexHolder>
        }

        return (

            <Draggable
                draggableId={this.props.task.id} 
                index={this.props.index}
                isDragDisabled={isDragDisabled}
            >
                {(provided, snapshot) => (
                    <Container
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        isDragging={snapshot.isDragging}
                        isDragDisabled={isDragDisabled}
                    >
                        {taskId}
                        {this.props.task.content}
                    </Container>
                )}
            </Draggable>
        )
    }
}


// WEBPACK FOOTER //
// ./src/DnDTask.js